"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColGroup = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function TableColGroup(_a) {
    var columns = _a.columns;
    return (react_1.default.createElement("colgroup", null, columns.map(function (_a) {
        var key = _a.key, width = _a.width;
        return (react_1.default.createElement("col", { key: key, style: {
                width: typeof width === "undefined" ? "auto" : width,
            } }));
    })));
}
exports.TableColGroup = TableColGroup;
TableColGroup.displayName = "TableColGroup";
//# sourceMappingURL=TableColGroup.js.map